import { Logo, LogoDaLoja } from '../ui';
import css from './LojaNoTopo.module.css';
import { useLoja } from './loja';

// A loja em destaque no painel (pedido do Matheus, 24/10): a logo dela (ou as iniciais) e o nome em tamanho
// de título no topo do menu e do celular; o EntregueCerto vira assinatura pequena no pé do menu.

/** "Vitória · ES"; sem cidade, nada. */
function localDaLoja(cidade: string | null, uf: string | null): string | null {
  if (!cidade) return null;
  return uf ? `${cidade} · ${uf}` : cidade;
}

/** Topo do menu do computador: logo larga em cima do nome; sem logo, iniciais ao lado do nome. */
export function LojaNoMenu() {
  const { empresa } = useLoja();
  const local = localDaLoja(empresa.cidade, empresa.uf);
  const comLogo = empresa.logo !== null;
  return (
    <div className={[css.loja, comLogo && css.comLogo].filter(Boolean).join(' ')}>
      <LogoDaLoja
        nome={empresa.nome}
        logo={empresa.logo}
        altura={comLogo ? 72 : 44}
        larguraMax={204}
      />
      <div className={css.texto}>
        <b className={css.nome}>{empresa.nome}</b>
        {local && <span className={css.local}>{local}</span>}
      </div>
    </div>
  );
}

/** Topo do celular e da meia tela: a logo (ou as iniciais) e o nome. */
export function LojaNoCelular() {
  const { empresa } = useLoja();
  return (
    <div className={css.celular}>
      <LogoDaLoja nome={empresa.nome} logo={empresa.logo} altura={36} larguraMax={88} />
      <b className={css.nomeCelular}>{empresa.nome}</b>
    </div>
  );
}

/** "por entreguecerto", pequeno, no pé do menu: a marca do sistema não some, mas não disputa com a loja. */
export function AssinaturaDoSistema() {
  return (
    <span className={css.assinatura}>
      por <Logo altura={13} solto />
    </span>
  );
}
